/**
 * Columns definition for the Round By Round votes table
 *
 * @param isAFLW
 * @param isPredictor
 * @returns {Array} Columns list
 */
export const composeColumnData = (isAFLW, isPredictor) => {
    let columns = [
        {
            Header: 'Rd',
            accessor: 'roundNumber'
        },
        {
            Header: 'Opponent',
            accessor: 'opponent'
        },
        ...(!isAFLW
            ? [
                  {
                      Header: isPredictor ? 'Predicted Votes' : 'Predicted',
                      accessor: 'predictedPoints'
                  }
              ]
            : []),
        ...(!isPredictor
            ? [
                  {
                      Header: 'Votes',
                      accessor: 'votes'
                  }
              ]
            : [])
    ];

    return columns;
};
